<nav aria-label="breadcrumb">
	<ol class="breadcrumb mb-0 pl-0">
		<li class="breadcrumb-item"><a href="/usuario-inicio">Mantenedor de usuario</a></li>
		<li class="breadcrumb-item active" aria-current="page"><a><strong>Editar</strong></a></li>
	</ol>
</nav>
<div class="row align-items-center">
	<a href="/usuario-inicio">
		<button class="btn boton_volver" data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER"><i
			class="bi bi-chevron-left mr-2"></i>Volver
		</button>
	</a>
	<h1 class="centrar_contenido offset-4">Editar usuario</h1>
</div>

<!-- DATOS USUARIOS -->

<div class="row mt-5">
	<p *ngIf="usuario">
		Usuario: <strong>{{usuario.username}}</strong> &nbsp;&nbsp;|&nbsp;&nbsp; Nombre: <strong>{{ usuario.nombre }} {{ usuario.apellidoPaterno }} {{ usuario.apellidoMaterno }}
		</strong>&nbsp;&nbsp;|&nbsp;&nbsp;Email: <strong>{{ usuario.correo }}</strong> 
	</p>
</div>
<!-- FIN DATOS USUARIOS -->

<!-- TABLA ROL -->
<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Seleccione un rol:</h6>
</div>

<table *ngIf="roles" class="table table-striped mt-5" aria-describedby="tabla roles">
	<thead class="header_tabla">
		<tr>
			<th scope="col" class="px-5">Rol</th>
			<th scope="col" class="px-5">Descripción</th>
			<th scope="col" class="text-center">Seleccionar</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let rol of roles; let i = index">
			<ng-container>
				<td class="px-5">{{ rol.nombre }}</td>
				<td class="px-5">{{ rol.descripcion }}</td>
				<td class="text-center">
					<div class="form-check">
						<input [disabled]="rolUsuario > rol.id && soloVisualizar" (click)="rolSeleccionado = rol.id" [checked]="rol.id === rolSeleccionado" class="form-check-input" type="radio" [id]="'rol-'+i">
						<label class="form-check-label" for="flexRadioDefault2">
						</label>
					</div>
				</td>
			</ng-container>
		</tr>
	</tbody>
</table>
<hr>

<!-- FIN TABLA ROL -->
	
<!-- SEDES -->
<div class="row mt-5 align-items-center">
	<div class="col-0">
		<div class="hr-amarillo mr-3"></div>
	</div>
	<div class="col-3 pl-0">
		<h6 class="mb-0 ">Seleccione las sedes:</h6>
	</div>
	<div class="col-8 d-flex justify-content-end">
		<p class="mr-3 mb-0">Habilitar todos:</p>
		
		<td>
			<label class="switch">
				<input [disabled]="soloVisualizar" type="checkbox" (click)="habilitarTodosFn($event)" [(ngModel)]="habilitarTodos" [checked]="habilitarTodos === true">
				<span class="slider round"></span>
			</label>&nbsp; {{ habilitarTodos ? 'Si' : 'No' }}
		</td>
	</div>
</div>
<!-- FIN SEDES -->
	
<!-- TABLA -->
<div style="margin-top: 30px;">
	<table *ngIf="renderSedesTable" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap " aria-describedby="tabla sedes">
		<thead class="header_tabla">
			<tr>
				<th class="py-2 px-5">Código</th>
				<th class="py-2 px-5">Descripción</th>
				<th class="py-2 px-5 text-center">Habilitar</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let sede of sedes">
				<td class="px-5">{{ sede.codigo }}</td>
				<td class="px-5">{{ sede.descripcion }}</td>
				<td class="px-5 text-center">
					<label class="switch">
						<input [disabled]="soloVisualizar" type="checkbox" (click)="checkSede()" [(ngModel)]="sede.habilitar" [checked]="sede.habilitar">
						<span class="slider round"></span>
					</label>&nbsp; 
					<p class="d-inline">{{ sede.habilitar ? 'Si' : 'No' }}</p>
				</td>
			</tr>
		</tbody>
	</table>
</div>
	
	<!-- FIN TABLA -->

<div class="row justify-content-center mb-8 mt-5" style="padding-bottom: 50px;">
	<a href="/usuario-inicio">
		<button *ngIf="!soloVisualizar" class="boton-secundario" data-toggle="tooltip" data-placement="top" title="CANCELAR"
		alt="CANCELAR">
		cancelar
		</button>
		<button *ngIf="soloVisualizar" class="boton-secundario" data-toggle="tooltip" data-placement="top" title="CANCELAR"
		alt="CANCELAR">
		Volver
		</button>
	</a>
	<button *ngIf="!soloVisualizar" (click)="modificarUsuario()" class="boton-primario tamanio_minimo ml-3" style="width:180px; padding:0;" data-toggle="tooltip" data-placement="top" title="CREAR"
	alt="CREAR">Guardar Cambios</button>
</div>

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
  Launch demo modal
</button>